import { render, staticRenderFns } from "./BaseCheckboxGroup.vue?vue&type=template&id=36da5226&scoped=true&"
import script from "./BaseCheckboxGroup.vue?vue&type=script&lang=js&"
export * from "./BaseCheckboxGroup.vue?vue&type=script&lang=js&"
import style0 from "./BaseCheckboxGroup.scss?vue&type=style&index=0&id=36da5226&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36da5226",
  null
  
)

export default component.exports